/* ------------------------------------------------------------------
   File: PrivateCapital.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-01-08
------------------------------------------------------------------ */

import React from 'react'

function StrategicCapital() {
  return (
    <div>
      StrategicCapitall Page
    </div>
  )
}

export default StrategicCapital
